import {styled, clsx} from 'external/material'
import useTranslations from 'hooks/translations'
import useMenu from 'hooks/menu'

const StyledDashboardContentTabButton = styled('div')(dashboardContentTabButtonStyles)

export default function DashboardContentTabButton({tab}) {
    const {dashboardTab, changeDashboardTab} = useMenu()
    const {translate} = useTranslations()
    const selected = dashboardTab == tab
    const handleClick = () => (selected || changeDashboardTab(tab))
    return(
    <StyledDashboardContentTabButton className={clsx('messages-title', {selected})} onClick={handleClick}>
        {translate(tab)}
    </StyledDashboardContentTabButton>
    )
}

function dashboardContentTabButtonStyles(){
    return {
        padding: '6px 15px',
        borderRadius: 20,
        cursor: 'pointer',
        color: '#8b909e',
        backgroundColor: '#f4f5f8',
        border: 'solid 1px #8b909e',
        '&:hover': {
           color: '#3e3a3a' 
        },
        '&.selected': {
            cursor: 'default',
            fontWeight: 'bold',
            color: '#fff',
            backgroundColor: '#1bb6ff',
            border: 'solid 1px #1bb6ff',
            '&:hover': {
               color: '#fff'
            }
        }
    }
}
